const RESET_PASSWORD_TRANSLATION_STRING: any = {
  errors: {
    match: {
      english: 'Passwords must match.',
      spanish: 'Las contraseñas deben ser iguales.',
    },
    minlength: {
      english: 'Password must be at least 8 characters long.',
      spanish: 'Introduzca una contraseña que tenga al menos 8 caracteres.',
    },
    pattern: {
      english:
        'Passwords must contain 1 uppercase character (A-Z) and 1 special character ' +
        '(~!@#$%^&*_-+=`|\\(){}[]:;"\'<>,.?/).',
      spanish:
        'Las contraseñas deben contener 1 carácter en mayúscula (A-Z) y 1 carácter especial ' +
        '(~!@#$%^&*_-+=`|\\(){}[]:;"\'<>,.?/).',
    },
  },
  success: {
    english: 'Success: Your password has been reset.',
    spanish: 'Éxito: Se ha restablecido su contraseña.',
  },
  title: {
    english: 'Please create your password',
    spanish: 'Cree su contraseña',
  },
  instruction: {
    paragraph: {
      english:
        'Please enter a password that is at least 8 characters and contains the following:',
      spanish:
        'Introduzca una contraseña que tenga al menos 8 caracteres y que contenga lo siguiente:',
    },
    uppercase: {
      english: '1 uppercase character (A-Z)',
      spanish: '1 carácter en mayúscula (A-Z)',
    },
    specialChar: {
      english: '1 special character (~!@#$%^&*_-+=`|\\(){}[]:;"\'<>,.?/)',
      spanish: '1 carácter especial (~!@#$%^&*_-+=`|\\(){}[]:;"\'<>,.?/)',
    },
  },
  newPwd: {
    english: 'New password',
    spanish: 'Nueva contraseña',
  },
  confirmPwd: {
    english: 'Confirm new password',
    spanish: 'Confirme la nueva contraseña',
  },
  submit: {
    english: 'Submit',
    spanish: 'Enviar',
  },
};

export { RESET_PASSWORD_TRANSLATION_STRING as translationString };
